import type { ReactNode } from 'react';

interface StatCardProps {
  title: string;
  value: ReactNode;
  trend?: string;
  trendType?: 'up' | 'down' | 'flat';
  hint?: string;
}

const trendColor = {
  up: 'text-risk-major',
  down: 'text-risk-low',
  flat: 'text-slate-500',
};

export default function StatCard({ title, value, trend, trendType = 'flat', hint }: StatCardProps) {
  return (
    <div className="bg-white rounded-xl p-[18px] shadow-card border border-slate-100">
      <div className="text-[12px] text-slate-500 mb-2">{title}</div>
      <div className="flex items-baseline gap-2">
        <span className="text-[26px] font-semibold text-slate-900">{value}</span>
        {trend && <span className={`text-[12px] ${trendColor[trendType]}`}>{trend}</span>}
      </div>
      {hint && <div className="text-[11px] text-slate-400 mt-2">{hint}</div>}
    </div>
  );
}
